import axios, { AxiosError, AxiosResponse } from 'axios';
import { ADMIN_LOGIN, ORGANIZER_BASE, ORGANIZER_LOGIN } from '@/config/routes';

const BASE_URL = import.meta.env.VITE_API_URL || '/api/v1';

export const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 15_000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

apiClient.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    if (
      error.response?.status === 401 &&
      !window.location.pathname.endsWith('/login')
    ) {
      const isOrganizerPanel = window.location.pathname.startsWith(ORGANIZER_BASE);
      window.location.href = isOrganizerPanel ? ORGANIZER_LOGIN : ADMIN_LOGIN;
    }
    return Promise.reject(error);
  },
);

export default apiClient;
